/*
/women が iframe で埋め込むスキルマップの見本 (/skillmap/demo) では、計測を動かさない。
計測は親のページ (/women) が済ませていて、枠の中でも動かすと GTM、PostHog、Sentry が二重に読まれ、
訪問と閲覧も二重に数えられるため。

埋め込む側は src に ?embed=1 を付ける (apps/women-astro の書き出し)。この住所と印が揃ったときだけ止め、
印の無い直接の訪問 (/skillmap/demo) は今までどおり計測する。
サーバーの描画 (root.tsx) とブラウザの初期化で同じ判定を使う。
デモのエディター (/demo/editor) の真ん中の作り物の画面 (/demo/editor/ide) も同じ。外の頁が計測していて、枠の中は印なしで止める。
*/

const MUTED_PATH = "/skillmap/demo";

const MUTED_FRAME_PATH = "/demo/editor/ide";

export function isAnalyticsMutedEmbed(pathname: string, search: string) {
  if (pathname === MUTED_FRAME_PATH) return true;
  return pathname === MUTED_PATH && new URLSearchParams(search).get("embed") === "1";
}

let mutedAtLoad: boolean | undefined;

/**
 * ブラウザで、最初に開いた住所が計測を止める埋め込みかどうか。
 * 枠の中で別の画面へ移っても、最初の判定を変えない (途中から計測が始まって二重にならないように)
 */
export function isAnalyticsMutedForThisLoad() {
  if (typeof window === "undefined") return false;
  mutedAtLoad ??= isAnalyticsMutedEmbed(
    window.location.pathname,
    window.location.search,
  );
  return mutedAtLoad;
}
